import { ContainerModule } from 'inversify';
import React, { FC, memo } from 'react';

import { DIContainerProvider } from '../provider/di';

export function loadDIModules<T extends object>(Component: FC<T>, ...modules: ContainerModule[]) {
  const result = memo<T>(props => (
    <DIContainerProvider modules={modules}>
      <Component {...props} />
    </DIContainerProvider>
  ));

  result.displayName = 'loadDIModules';

  return result;
}
